import { render } from "./CategoriesClouds.vue?vue&type=template&id=efdbf6f0"
import script from "./CategoriesClouds.vue?vue&type=script&lang=js"
export * from "./CategoriesClouds.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__